import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./auth/components/login/login.component";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { ViewsComponent } from "./views/views.component";
import { AuthGuard } from "./_helpers/auth.guard.service";

const routes: Routes = [
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },

  { path: "", redirectTo: "auth", pathMatch: "full" },
  {
    path: "edit-profile",
    component: EditProfileComponent,
  },
  {
    path: "",
    component: ViewsComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "change-password", component: EditProfileComponent },

      {
        path: "manage-club",
        loadChildren: () =>
          import("./views/registered-club/registered-club.module").then((m) => m.RegisteredClubModule),
      },

      {
        path: "manage-players",
        loadChildren: () =>
          import("./views/register-players/register-players.module").then((m) => m.RegisterPlayersModule),
      },

      {
        path: "manage-restaurants",
        loadChildren: () =>
          import("./views/manage-restaurants/manage-restaurants.module").then((m) => m.ManageRestaurantsModule),
      },

      {
        path: "manage-orders",
        loadChildren: () =>
          import("./views/manage-orders/manage-orders.module").then((m) => m.ManageOrdersModule),
      },

      {
        path: "dashboard",
        loadChildren: () =>
        import("../app/dashboard/dashboard.module").then(
          (m) => m.DashboardModule
        )
      },

      {
        path: "manage-admins",
        loadChildren: () =>
        import("./views/manage-admins/manage-admins.module").then(
          (m) => m.ManageAdminsModule
        )
      },
    ],
  },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
